<template>
  <button
    type="button"
    class="global-search-result-card"
    @click="$emit('select')"
  >
    <div class="global-search-result-card__poster">
      <OptimizedImage
        v-if="item.picture"
        :src="item.picture"
        :alt="item.title"
        cover
        width="64"
        height="96"
        size="thumb"
        loading="lazy"
      />
      <div v-else class="global-search-result-card__poster-placeholder">
        <v-icon :icon="posterIcon" size="28" color="grey" />
      </div>
    </div>
    <div class="global-search-result-card__body">
      <div class="global-search-result-card__title">{{ item.title }}</div>
      <div class="global-search-result-card__meta">
        <span v-if="item.year" class="global-search-result-card__year">{{ item.year }}</span>
        <template v-if="item.rate != null && item.rate > 0">
          <v-icon v-if="item.year" size="14" class="mx-1" style="opacity: 0.7">mdi-circle-small</v-icon>
          <v-icon size="14" class="global-search-result-card__star">mdi-star</v-icon>
          <span class="global-search-result-card__rate">{{ formatRate(item.rate) }}</span>
        </template>
        <span v-if="item.place" class="global-search-result-card__place">
          {{ item.year || item.rate != null ? ' · ' : '' }}{{ item.place }}
        </span>
      </div>
      <div
        v-if="item.genres && item.genres.length"
        class="global-search-result-card__genres"
        :class="'global-search-result-card__genres--' + (item.type === 'tvshow' ? 'series' : item.type === 'movie' ? 'movies' : 'shows')"
      >
        <span
          v-for="(g, i) in item.genres.slice(0, 4)"
          :key="i"
          class="global-search-result-card__genre-tag"
        >
          {{ g }}
        </span>
      </div>
    </div>
  </button>
</template>

<script setup>
import { computed } from 'vue'
import OptimizedImage from '@/components/shared/OptimizedImage.vue'

const props = defineProps({
  item: { type: Object, required: true },
})

defineEmits(['select'])

const posterIcon = computed(() => {
  if (props.item.type === 'movie') return 'mdi-movie-open'
  if (props.item.type === 'tvshow') return 'mdi-television'
  return 'mdi-theater'
})

function formatRate(rate) {
  if (rate == null) return ''
  const n = Number(rate)
  return Number.isFinite(n) ? n.toFixed(1) : ''
}
</script>

<style scoped>
.global-search-result-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  text-align: left;
  border: none;
  border-radius: 10px;
  background: rgb(9, 9, 11);
  cursor: pointer;
  font: inherit;
  transition: background 0.15s ease;
}
.global-search-result-card:hover {
  background: rgb(18, 18, 22);
}
.global-search-result-card__poster {
  flex-shrink: 0;
  width: 64px;
  height: 96px;
  border-radius: 6px;
  overflow: hidden;
  background: rgb(39, 38, 43);
}
.global-search-result-card__poster-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.global-search-result-card__body {
  flex: 1;
  min-width: 0;
}
.global-search-result-card__title {
  font-weight: 600;
  font-size: 0.9375rem;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.global-search-result-card__meta {
  font-size: 0.8125rem;
  color: rgba(var(--v-theme-on-surface), 0.7);
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
}
.global-search-result-card__star {
  color: rgb(252, 198, 3);
  margin-right: 2px;
}
.global-search-result-card__rate {
  font-weight: 500;
}
.global-search-result-card__place {
  opacity: 0.9;
}
.global-search-result-card__genres {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.global-search-result-card__genre-tag {
  font-size: 0.6875rem;
  padding: 2px 8px;
  border-radius: 4px;
}
.global-search-result-card__genres--series .global-search-result-card__genre-tag {
  background: rgb(37, 10, 59);
  color: rgb(213, 173, 250);
}
.global-search-result-card__genres--movies .global-search-result-card__genre-tag {
  background: rgb(53, 6, 32);
  color: rgb(246, 160, 209);
}
.global-search-result-card__genres--shows .global-search-result-card__genre-tag {
  background: rgb(10, 26, 58);
  color: rgb(138, 193, 250);
}
</style>
